
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7010"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7010"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("blDKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1204bd2236c42f3$export$2e2bcd8739ae039; });
/**************************************************************************
 * File: application.ts
 * Notes: Extended application functions
 **************************************************************************/ 
var $bydUt = parcelRequire("bydUt");

var $hO9L1 = parcelRequire("hO9L1");

var $9Y7aH = parcelRequire("9Y7aH");
const $c1204bd2236c42f3$var$API = Mindbreeze['require']('api/v2/api');
const $c1204bd2236c42f3$var$BaseApplication = Mindbreeze['require']('client/application');
const $c1204bd2236c42f3$var$$ = Mindbreeze['require']('jquery');
const $c1204bd2236c42f3$var$Application = $c1204bd2236c42f3$var$BaseApplication.extend((0, $bydUt.default)).extend({
    fetchPreviewContent: function(origin, location, category, categoryinstance) {
        return fetch(`${window.location.origin}/search/api/v2/preview`, // `https://nyc-dev.mindbreeze.com/search/api/v2/preview`, // For VM testing only
        {
            method: "POST",
            body: JSON.stringify({
                location: location,
                category: category,
                categoryinstance: categoryinstance,
                query_expr: {
                    and: [
                        {
                            unparsed: "",
                            id: "query"
                        }
                    ]
                },
                full_html: true,
                properties: [
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "title"
                    },
                    {
                        formats: [
                            "PROPERTY"
                        ],
                        name: "mes:summary"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "content"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "extension"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "html/head"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "categoryclass"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "@content"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "i18n.document-not-found"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "icon"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "i18n.date"
                    },
                    {
                        formats: [
                            "PROPERTY"
                        ],
                        name: "mes:date"
                    }
                ],
                user_context: {
                    referer: origin + "/search/apps/summary-demo/",
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/summary-demo/", // For VM testing only
                    locale: "en-US",
                    service_id: origin + "/search/apps/scripts/../scripts/../../api/v2/",
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/scripts/../scripts/../../api/v2/", // For VM testing only
                    utc_time_zone_differential_in_seconds: 3600,
                    service_url: origin + "/search/apps/scripts/../../api/v2/preview"
                }
            }),
            credentials: "include",
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }).then((response)=>response.text()).then((body)=>{
            return JSON.parse(body).result.properties[3].data[0].html;
        });
    },
    /*summarizeDocument: async function () {
        this.models.search.set("constraint", {
          and: [
            {
              label: "fqcategory",
              quoted_term:
                this.options.resultModel.get("category", {
                  format: "VALUE",
                }) +
                ":" +
                this.options.resultModel.get("categoryinstance", {
                  format: "VALUE",
                }),
            },
            {
              label: "mes:key",
              quoted_term: this.options.resultModel.get("mes:key", {
                format: "VALUE",
              }),
            },
          ],
        });
        const keys = this.options.resultModel.get("mes:key", {
          format: "VALUE",
        });
        const keysElement = document.getElementById("meskey");
        if (keysElement) {
          keysElement.innerHTML = keys;
        }
      },

      summarize: async function (options: any) {
        
        const content = await this.fetchPreviewContent(
          window.location.origin,
          options.model.get("location", { format: "VALUE" }),
          options.model.get("category", { format: "VALUE" }),
          options.model.get("categoryinstance", { format: "VALUE" })
        ).then((response: any) => {
          return response;
        });
        
        const llmModelElement = document.getElementById("LLMmodel");
        if (llmModelElement) {
          llmModelElement.innerHTML =
            "0e92cb9d-edce-4dce-957a-d7420c903ee6"; // LLM ID
        }
        const llmModelNameElement =
          document.getElementById("LLMmodelName");
        if (llmModelNameElement) {
          llmModelNameElement.innerHTML = "mindbreeze llm"; //llm model for feedback
        }
        const summarizePromptElement =
          document.getElementById("summarizePrompt");
        if (summarizePromptElement) {
          summarizePromptElement.setAttribute(
            "data-prompt-user-message-template",
            content
          );
        }
         this.pushStack({
          title:
            "Document summary of: " +
            options.model.get("title", { format: "VALUE" }),
          "template-ref": "summaryTemplate",
          action: "summarizeDocument",
          applicationOptions: {
            startSearch: false,
            resultModel: options.model,
          },
        });
      },

      draftDecisionDocument: async function () {
        this.models.search.set("constraint", {
          and: [
            {
              label: "fqcategory",
              quoted_term:
                this.options.resultModel.get("category", {
                  format: "VALUE",
                }) +
                ":" +
                this.options.resultModel.get("categoryinstance", {
                  format: "VALUE",
                }),
            },
            {
              label: "mes:key",
              quoted_term: this.options.resultModel.get("mes:key", {
                format: "VALUE",
              }),
            },
          ],
        });
        const keys = this.options.resultModel.get("mes:key", {
          format: "VALUE",
        });
        const keysElement = document.getElementById("meskey");
        if (keysElement) {
          keysElement.innerHTML = keys;
        }
      },

      draftDecision: async function (options: any) {
        
        const content = await this.fetchPreviewContent(
          window.location.origin,
          options.model.get("location", { format: "VALUE" }),
          options.model.get("category", { format: "VALUE" }),
          options.model.get("categoryinstance", { format: "VALUE" })
        ).then((response: any) => {
          return response;
        });
        
        const llmModelElement = document.getElementById("LLMmodel");
        if (llmModelElement) {
          llmModelElement.innerHTML =
            "0e92cb9d-edce-4dce-957a-d7420c903ee6"; // LLM ID
        }
        const llmModelNameElement =
          document.getElementById("LLMmodelName");
        if (llmModelNameElement) {
          llmModelNameElement.innerHTML = "mindbreeze llm"; //llm model for feedback
        }
        const draftDecisionPromptElement =
          document.getElementById("draftDecisionPrompt");
        if (draftDecisionPromptElement) {
          draftDecisionPromptElement.setAttribute(
            "data-prompt-user-message-template",
            content
          );
        }
         this.pushStack({
          title:
            "Decision draft of: " +
            options.model.get("title", { format: "VALUE" }),
          "template-ref": "decisionTemplate",
          action: "draftDecisionDocument",
          applicationOptions: {
            startSearch: false,
            resultModel: options.model,
          },
        });
      },*/ /*************************************************************************
   * Name: createModels
   * Params: 
   * Purpose: Called before the first views/widgets are initialized and
   *          when the app is initialized
   *************************************************************************/ createModels: function() {
        this.listenTo(this, "all", function() {
            console.log('all log', arguments);
        });
        this.createUiStateModel();
    },
    /*************************************************************************
   * Name: prepareModels
   * Params: 
   * Purpose: Called when the application is initializing and create models
   *          has been called
   *************************************************************************/ prepareModels: function() {
        this.prepareSearchModel();
        this.connectModels();
        //called on each results to build and add download actions
        const addCustomActionsTransformer = function(responseData) {
            return new Promise((resolve)=>{
                responseData.resultset.results.forEach((result)=>{
                    const downloadAction = buildDownloadAction(result);
                    if (downloadAction) addAction(result, downloadAction);
                    const shareAction = buildShareAction(result);
                    if (shareAction) addAction(result, shareAction);
                });
                resolve();
            });
        };
        this.models.search.output.loadTransformers.push(addCustomActionsTransformer);
        //builds download action
        function buildDownloadAction(result) {
            var _result_properties_find_properties_find_data__value_action_preview, _result_properties_find_properties_find_data__value_action, _result_properties_find_properties_find_data_, _result_properties_find_properties_find, _result_properties_find, _result_properties;
            const title = result.properties.find((el)=>el.id == "title").properties[0].data[0].value.str;
            var current_location = null;
            if (result === null || result === void 0 ? void 0 : (_result_properties = result.properties) === null || _result_properties === void 0 ? void 0 : (_result_properties_find = _result_properties.find((el)=>el.id == "actions")) === null || _result_properties_find === void 0 ? void 0 : (_result_properties_find_properties_find = _result_properties_find.properties.find((el)=>el.id == "Preview")) === null || _result_properties_find_properties_find === void 0 ? void 0 : (_result_properties_find_properties_find_data_ = _result_properties_find_properties_find.data[0]) === null || _result_properties_find_properties_find_data_ === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action = _result_properties_find_properties_find_data_.value.action) === null || _result_properties_find_properties_find_data__value_action === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action_preview = _result_properties_find_properties_find_data__value_action.preview) === null || _result_properties_find_properties_find_data__value_action_preview === void 0 ? void 0 : _result_properties_find_properties_find_data__value_action_preview.content_location) {
                var _result_properties1;
                current_location = new URL((_result_properties1 = result.properties) === null || _result_properties1 === void 0 ? void 0 : _result_properties1.find((el)=>el.id == "actions").properties.find((el)=>el.id == "Preview").data[0].value.action.preview.content_location);
                current_location.pathname = "/search/content";
            } else return null;
            return {
                id: "Download",
                name: "Download",
                data: [
                    {
                        html: `<a tabindex="0" role="button" data-action="downloadDocument('${current_location}', '${title}')">Download</a>`,
                        value: {
                            href: current_location,
                            rel: "action"
                        },
                        actionId: "Download"
                    }
                ]
            };
        }
        // builds Share action
        function buildShareAction(result) {
            var _result_properties_find_properties_find_data__value_action_preview, _result_properties_find_properties_find_data__value_action, _result_properties_find_properties_find_data__value, _result_properties_find_properties_find_data_, _result_properties_find_properties_find_data, _result_properties_find_properties_find, _result_properties_find_properties, _result_properties_find, _result_properties;
            const contentLocation = result === null || result === void 0 ? void 0 : (_result_properties = result.properties) === null || _result_properties === void 0 ? void 0 : (_result_properties_find = _result_properties.find((el)=>el.id === "actions")) === null || _result_properties_find === void 0 ? void 0 : (_result_properties_find_properties = _result_properties_find.properties) === null || _result_properties_find_properties === void 0 ? void 0 : (_result_properties_find_properties_find = _result_properties_find_properties.find((el)=>el.id === "Preview")) === null || _result_properties_find_properties_find === void 0 ? void 0 : (_result_properties_find_properties_find_data = _result_properties_find_properties_find.data) === null || _result_properties_find_properties_find_data === void 0 ? void 0 : (_result_properties_find_properties_find_data_ = _result_properties_find_properties_find_data[0]) === null || _result_properties_find_properties_find_data_ === void 0 ? void 0 : (_result_properties_find_properties_find_data__value = _result_properties_find_properties_find_data_.value) === null || _result_properties_find_properties_find_data__value === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action = _result_properties_find_properties_find_data__value.action) === null || _result_properties_find_properties_find_data__value_action === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action_preview = _result_properties_find_properties_find_data__value_action.preview) === null || _result_properties_find_properties_find_data__value_action_preview === void 0 ? void 0 : _result_properties_find_properties_find_data__value_action_preview.content_location;
            if (!contentLocation) return null;
            // Encode the URL before putting it into the HTML/JavaScript attribute.
            const encodedLocation = encodeURIComponent(contentLocation);
            return {
                id: "Share",
                name: "Share",
                data: [
                    {
                        html: `<a tabindex="0" role="button" onclick="shareDocument('${encodedLocation}', this); return false;">Share</a>`,
                        value: {
                            href: contentLocation,
                            rel: "action"
                        },
                        actionId: "Share"
                    }
                ]
            };
        }
        //adds action to result
        function addAction(result, action) {
            var _result_properties, _result_properties1;
            if (!((_result_properties = result.properties) === null || _result_properties === void 0 ? void 0 : _result_properties.find((el)=>el.id == "actions"))) return false;
            (_result_properties1 = result.properties) === null || _result_properties1 === void 0 ? void 0 : _result_properties1.find((el)=>el.id == "actions").properties.push(action);
        }
    },
    createUiStateModel: function() {
        this.models.uiState = new (0, $hO9L1.default)();
    },
    prepareSearchModel: function() {
        this.listenTo($c1204bd2236c42f3$var$API.search, 'loadoutput', this.beforeSearchModelOutputUpdate);
    // this.listenTo(this.models.search, 'computed', this.doSomethingWhenResultsAreAvailable);
    },
    connectModels: function() {
    //this.listenTo(this.models.uiState, 'change:language', this.updateLanguage);
    },
    beforeSearchModelOutputUpdate: function(model, atts, options) {
        if (model === this.models.search.output) {
            var _atts_resultset;
            const results = (atts === null || atts === void 0 ? void 0 : (_atts_resultset = atts.resultset) === null || _atts_resultset === void 0 ? void 0 : _atts_resultset.results) || (atts === null || atts === void 0 ? void 0 : atts.results);
            try {
                this.customizeSortSwitch(model, atts, options);
            } catch (error) {
                console.log('Customize Switch Error', error);
            }
            if (results) results.forEach((result)=>{
                this.addGeneratedProperty(result);
            });
        }
    },
    addGeneratedProperty: function(result) {
        const key = (0, $9Y7aH.getPropertyValue)(result, 'mes:key');
        result.properties['generatedProperty'] = (0, $9Y7aH.createHtmlProperty)('generatedProperty', key);
    },
    /*************************************************************
     * Name: customizeSortSwitch
     * Purpose: Update sthe sort switch widget for customer needs
     * Params: model
     *         atts
     *         options
     *************************************************************/ customizeSortSwitch: function(model, atts, options) {
        const orderable = [
            {
                name: 'mes:relevance',
                localized_name: 'Relevance'
            },
            {
                name: 'mes:date',
                localized_name: "Decision Date"
            }
        ];
        atts.orderable = orderable;
    }
});
$c1204bd2236c42f3$var$Application.launch = ()=>{
    window.app = new $c1204bd2236c42f3$var$Application({
        initializeModels: (app)=>app.createModels()
    });
    // close welcome modal if user clicks outside of modal content
    window.onclick = function(event) {
        if (event.target.id == 'welcomeModal') this.app.closeWelcomeModal();
    };
    // download function
    window.downloadDocument = async function(url, title) {
        try {
            const response = await fetch(url, {
                credentials: "include"
            });
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = title + ".pdf";
            a.click();
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error downloading document:", error.message);
        }
    };
    // share function
    window.shareDocument = async function(encodedUrl, clickedElement) {
        const url = decodeURIComponent(encodedUrl);
        try {
            await navigator.clipboard.writeText(url);
            showShareNotification("Link copied to clipboard!", clickedElement);
        } catch (error) {
            console.error("Error copying link to clipboard:", error);
            showShareNotification("Unable to copy the link. Please copy it manually.", clickedElement);
        }
    };
    // share notification
    function showShareNotification(message, clickedElement) {
        let notification = document.getElementById("shareNotification");
        if (!notification) {
            notification = document.createElement("div");
            notification.id = "shareNotification";
            notification.style.position = "fixed";
            notification.style.zIndex = "9999";
            notification.style.padding = "8px 14px";
            notification.style.backgroundColor = "#333";
            notification.style.color = "#fff";
            notification.style.borderRadius = "4px";
            notification.style.boxShadow = "0 2px 8px rgba(0,0,0,0.25)";
            notification.style.fontSize = "14px";
            notification.style.transition = "opacity 0.3s ease";
            document.body.appendChild(notification);
        }
        notification.textContent = message;
        const rect = clickedElement.getBoundingClientRect();
        notification.style.left = `${rect.left}px`;
        notification.style.top = `${rect.bottom + 8}px`;
        notification.style.opacity = "1";
        clearTimeout(notification.hideTimeout);
        notification.hideTimeout = setTimeout(()=>{
            notification.style.opacity = "0";
        }, 2000);
    }
};
var $c1204bd2236c42f3$export$2e2bcd8739ae039 = $c1204bd2236c42f3$var$Application;

});
parcelRegister("bydUt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f63f4d8cbab2f86$export$2e2bcd8739ae039; });
/**************************************************************************
 * File: actions.ts
 * Notes: Functions for user and UI actions.
 **************************************************************************/ const $0f63f4d8cbab2f86$var$$ = Mindbreeze['require']('jquery'); //initialize jquery library
var $0f63f4d8cbab2f86$export$2e2bcd8739ae039 = {
    /************************************************
   * Name: closeWelcomeModal
   * Note: Close the welcome modal
   ***********************************************/ closeWelcomeModal: function() {
        var welcomeModal = $0f63f4d8cbab2f86$var$$('#welcomeModal');
        welcomeModal.hide();
    }
};

});

parcelRegister("hO9L1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c988b464960b1df$export$2e2bcd8739ae039; });

var $hiDPQ = parcelRequire("hiDPQ");
class $6c988b464960b1df$var$UiState extends (0, $hiDPQ.default) {
    defaults() {
        return {
            language: document.documentElement.lang
        };
    }
}
var $6c988b464960b1df$export$2e2bcd8739ae039 = $6c988b464960b1df$var$UiState;

});
parcelRegister("hiDPQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14ba747ac41fe251$export$2e2bcd8739ae039; });
const $14ba747ac41fe251$var$Model = Mindbreeze['require']('backbone').Model;
const $14ba747ac41fe251$var$PropertiesModel = Mindbreeze['require']('model/properties');
class $14ba747ac41fe251$export$2e2bcd8739ae039 extends $14ba747ac41fe251$var$Model {
    get(key) {
        return new $14ba747ac41fe251$var$PropertiesModel(this.attributes).get(key, {
            format: 'VALUE'
        });
    }
    set(key, val, options, ...rest) {
        if (key == null) return this;
        var attrs;
        if (typeof key === 'object') {
            attrs = key;
            options = val;
        } else (attrs = {})[key] = val;
        super.set(key, val, options, ...rest);
    }
    submodel(path) {
        return this.get(path);
    }
}

});


parcelRegister("9Y7aH", function(module, exports) {

$parcel$export(module.exports, "getPropertyValue", function () { return $ed5b61dfc7f3842e$export$698ea9d8553982f9; });
$parcel$export(module.exports, "createHtmlProperty", function () { return $ed5b61dfc7f3842e$export$abfb758ba901fe79; });
const $ed5b61dfc7f3842e$var$PropertiesModel = Mindbreeze['require']('model/properties');
function $ed5b61dfc7f3842e$export$698ea9d8553982f9(result, propertyName) {
    if (!result) return;
    return new $ed5b61dfc7f3842e$var$PropertiesModel(result.properties).get(propertyName, {
        format: 'VALUE'
    });
}
function $ed5b61dfc7f3842e$export$abfb758ba901fe79(propertyName, ...html) {
    return {
        id: propertyName,
        name: propertyName,
        data: html.map((value)=>({
                html: value
            }))
    };
}

});


/**************************************************************************
 * File: index.ts
 * Notes: Base javascript script used to import client js libraries and
 * initialize application. All extended application is found in
 * application.js
 **************************************************************************/ const $29f7cf1ab554bdf0$var$MINDBREEZE_IMPORTS = [
    'api/v2/api',
    'client/application',
    'i18n/i18n',
    'model/properties',
    'backbone',
    'jquery'
];

Mindbreeze['require']($29f7cf1ab554bdf0$var$MINDBREEZE_IMPORTS, ()=>{
    const Application = (parcelRequire("blDKu")).default;
    Application.launch();
});


//# sourceMappingURL=html.5110009b.js.map
